module.exports = __webpack_public_path__ + "img/icon_scope.8487fb89.svg";